import { withInstall } from '@bigin/utils'
import Progress from './src/progress.vue'

export const BProgress = withInstall(Progress)
export default BProgress

export * from './src/progress'
